import React from 'react';

import Link from 'next/link';
import { useMutation } from 'react-query';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';

import LoginPrompt from '../loginprompt/LoginPrompt';
import Modal from '@core/components/Modal/Modal';

import {
	AddToWishlistCourseService,
	AddToWishlistLectureService,
	RemoveFromWishlistCourseService,
	RemoveFromWishlistLectureService
} from 'services/core';

import { Lacking, Purchasing } from 'constants/content-status';

import WishList from 'assets/icons/wishlist-icon.svg';
import WishListExist from 'assets/icons/wishlist-exist-icon.svg';
import WishlistAdded from 'assets/icons/wishlist-added.svg';
// import CloseSquare from '@core/assets/icons/close-square.svg';

import classes from './WishlistButton.module.scss';
import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

const WishlistButton = ({ content_id, status, content, exist, refetchOverview }) => {
	const { ToastContainer, toast } = UseToast();
	const {
		show: loginNoticeVisible,
		showModal: loginNoticeShowModal,
		destroyModal: loginNoticeDestroyModal
	} = UseModal();
	const { mutate: callAddToWishlist, isLoading: addWishlistLoading } = useMutation(
		content === 'job-qualification' ? AddToWishlistCourseService : AddToWishlistLectureService,
		{
			onSuccess: () => {
				refetchOverview();
				toast(
					<div
						className={`${classes['added-wishlist']} d-flex flex-row align-items-center justify-content-center`}>
						<WishlistAdded />
						<p className="m-0">
							{content === 'job-qualification' ? 'Job qualification' : 'Course'} added to wishlist
						</p>
						<Link href="/wishlist">WishList</Link>
					</div>
				);
			},
			onError: (error) => {
				if (error.response.status === 401) {
					loginNoticeShowModal();
				} else {
					let toasterror = 'Something went wrong!';
					typeof error.response.data.data === 'string' && (toasterror = error.response.data.data);
					typeof error.response.data.data === 'object' &&
						(toasterror =
							error.response.data.data?.messages && error.response.data.data?.messages[0]?.message);
					toast(toasterror || 'Something went wrong!', 'Alert');
				}
			}
		}
	);
	const { mutate: callRemoveFromWishlist, isLoading: removeWishlistLoading } = useMutation(
		content === 'job-qualification' ? RemoveFromWishlistCourseService : RemoveFromWishlistLectureService,
		{
			onSuccess: () => {
				refetchOverview();
				toast(`${content === 'job-qualification' ? 'Job qualification' : 'Course'} removed from wishlist`);
			},
			onError: (error) => {
				let toasterror = 'Something went wrong!';
				typeof error.response.data.data === 'string' && (toasterror = error.response.data.data);
				typeof error.response.data.data === 'object' &&
					(toasterror =
						error.response.data.data?.messages && error.response.data.data?.messages[0]?.message);
				toast(toasterror || 'Something went wrong!', 'Alert');
			}
		}
	);

	return (
		<>
			<ToastContainer />
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={loginNoticeDestroyModal}
				show={loginNoticeVisible}>
				<div
					className={`${classes['login-notice-modal']} d-flex flex-column justify-content-center container`}>
					<div className={`d-flex flex-column align-items-center justify-content-center`}>
						<LoginPrompt />
					</div>
				</div>
			</Modal>
			{(status === Lacking || status === Purchasing) && exist ? (
				<button
					disabled={removeWishlistLoading}
					onClick={() => callRemoveFromWishlist(content_id)}
					className={`${classes['wishlist-button']} ${classes['exist']} d-flex flex-row justify-content-center align-items-center`}>
					<WishListExist />
					{/* <span className="d-none d-xl-inline">Added to wishlist</span> */}
				</button>
			) : (
				(status === Lacking || status === Purchasing) && (
					<button
						disabled={addWishlistLoading}
						onClick={() => callAddToWishlist(content_id)}
						className={`${classes['wishlist-button']} d-flex flex-row justify-content-center  align-items-center`}
						style={{ backgroundColor: `${content === 'job-qualification' ? '#f7f6f3' : '#fff'}` }}>
						<WishList />
						{/* <span className="d-none d-xl-inline">Add to wishlist</span> */}
					</button>
				)
			)}
		</>
	);
};

export default WishlistButton;
